import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../constants/path';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';
import { ENTERPRISE_CARD_NAME, ENTERPRISE_CARD_PARTNER_EBC_ID } from '../../../constants/ebon';

import { showModal } from '../../../services/modal/actions';
import { registerCart } from '../../../services/ebon/actions';

import useCartController from '../../../services/ebon/hooks/useCartController';

import { formatAmountCurrency } from '../../../utils';
import { convertDate } from '../../../utils/dateUtils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';
import { convertPartnerNameForUrl, displayableCashback } from '../../../services/partner/utils';

import Hidden from '../../Hidden/Hidden';
import BasketRowItem from '../merchantcard/BasketRowItem';
import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './EbonSelectorComponent.scss';

const EbonSelectorComponent = ({
    i18n,
    ebons,
    partner,
    registerCart,
    history,
    isAuthenticated,
    showModal,
    fetching,
    ebonPaymentConfig
}) => {
    const [selectedEbon, setSelectedEbon] = useState({});
    const [quantity, setQuantity] = useState(0);
    const [CGVAccepted, setCGVAccepted] = useState(false);
    const { availabilityResponses, ebonDiscount = {} } = ebons;
    const {
        cart,
        addItemCart,
        handleItemChange,
        getCartTotal,
        getCartQuantity
    } = useCartController();

    const fixed = ebonDiscount.cashback.value;
    const percent = ebonDiscount.cashback.percent.value;

    const cashback = displayableCashback(percent, fixed);
    const amountCashback = fixed > 0 ? fixed : percent;

    const hasFacialValues = ebons.availabilityResponses.length > 0;

    const basketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimit;

    const isEnterpriseCard = partner.ebcId === ENTERPRISE_CARD_PARTNER_EBC_ID;
    const partnerName = isEnterpriseCard ? ENTERPRISE_CARD_NAME : partner.name;

    const showLoginModal = event => {
        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGIN);
            return false;
        }
    };

    const doCartTotalCashbackAmount = cart => {
        const cartTotal = getCartTotal(cart);
        const totalCashbackAmount = (cartTotal * amountCashback) / 100;
        const normalizedCashBackNumber = formatAmountCurrency(totalCashbackAmount);
        return normalizedCashBackNumber;
    };

    const handleAddItem = (facialValue, quantityQuery, quantityAvailable) => {
        addItemCart({
            facialValue: facialValue || selectedEbon.facialValue,
            quantityQuery: quantityQuery || quantity,
            quantityAvailable: quantityAvailable,
            partnerId: ebons.ebonDiscount.partnerId
        });
    };

    const handleQuantity = e => {
        if (e === '-') {
            if (quantity > 1) {
                setQuantity(quantity - 1);
            }
        } else if (e === '+') {
            if (
                quantity < selectedEbon.quantityAvailable &&
                (!basketLimit || quantity < basketLimit)
            ) {
                setQuantity(quantity + 1);
            }
        }
    };

    useEffect(() => {
        const initQuantity =
            selectedEbon && selectedEbon.facialValue
                ? selectedEbon.facialValue.quantityQuery || 1
                : 1;
        setQuantity(initQuantity);
    }, [selectedEbon]);

    useEffect(() => {
        setSelectedEbon({});
    }, [partner]);

    const cartValidation = () => {
        registerCart(cart);
        const validationPath = `${PATH.EBON_VALIDATION_PATH}/${convertPartnerNameForUrl(
            partnerName
        )}-${partner.id}`;
        history.push(validationPath);
    };

    useEffect(() => {}, [selectedEbon]);

    const handleSelectEbon = e => {
        const ebonValue = e.target.value;
        const ebonSelected = availabilityResponses.find(
            ebon => ebon.facialValue.toString() === ebonValue
        );
        setSelectedEbon(ebonSelected ? ebonSelected : {});
    };

    const isEbonAvalaible = ebon => {
        if (ebon.quantityAvailable > 0 && ebon.expirationDate > 0) {
            return true;
        }
        return false;
    };

    const isBasketLimitReached = () => {
        const cartTotalQuantity = getCartQuantity(cart);
        return basketLimit && cartTotalQuantity >= basketLimit;
    };

    const getLabelResume = () => {
        return quantity > 1 ? i18n.RESUM_EBON_PLURAL : i18n.RESUM_EBON;
    };

    return (
        <div id="p-ebon-selector" className="container">
            {fetching ? (
                <div className="loading-div">
                    <LoadingComponent />
                </div>
            ) : (
                <React.Fragment>
                    <div className="left-container">
                        <p className="valueTips">
                            <span>{i18n.VALUE}</span>
                            {i18n.VALUE_TIPS}
                        </p>
                        <div className="ebon-selector-container">
                            <Hidden breakpoint="mdDown">
                                <div className="ebon-container">
                                    {!hasFacialValues && (
                                        <p className="no-availability">
                                            <b>{i18n.NO_EBON_AVAILABILITY}</b>
                                        </p>
                                    )}

                                    {availabilityResponses &&
                                        availabilityResponses
                                            .sort((a, b) => a.facialValue - b.facialValue)
                                            .map(ebon => (
                                                <button
                                                    key={ebon.facialValue}
                                                    onClick={() => {
                                                        if (
                                                            selectedEbon.facialValue ===
                                                            ebon.facialValue
                                                        ) {
                                                            setSelectedEbon({});
                                                        } else {
                                                            setSelectedEbon(ebon);
                                                        }
                                                    }}
                                                    className={`button-ebon ${
                                                        selectedEbon.facialValue ===
                                                        ebon.facialValue
                                                            ? 'selected'
                                                            : ''
                                                    }`}
                                                    disabled={!isEbonAvalaible(ebon)}>
                                                    <p className="value">
                                                        {formatAmountCurrency(ebon.facialValue)}
                                                    </p>
                                                    {!isEbonAvalaible(ebon) && (
                                                        <p className="soldOut">{i18n.SOLD_OUT}</p>
                                                    )}
                                                </button>
                                            ))}
                                </div>
                            </Hidden>
                            <Hidden breakpoint="mdUp">
                                {!hasFacialValues ? (
                                    <p className="no-availability">
                                        <b>{i18n.NO_EBON_AVAILABILITY}</b>
                                    </p>
                                ) : (
                                    <select
                                        name="ebons"
                                        className="ebon-select"
                                        value={selectedEbon.facialValue}
                                        onChange={handleSelectEbon}>
                                        <option value="">{i18n.MOBILE_SELECT}</option>
                                        {availabilityResponses.map((ebon, i) => (
                                            <option
                                                key={ebon.facialValue}
                                                value={ebon.facialValue}
                                                disabled={!isEbonAvalaible(ebon)}>
                                                {`${formatAmountCurrency(ebon.facialValue)} ${
                                                    !isEbonAvalaible(ebon)
                                                        ? '- ' + i18n.SOLD_OUT
                                                        : ''
                                                }`}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </Hidden>
                            <div>
                                <p className="availability">
                                    {convertHtmlToReactDomWithParams(
                                        i18n.EBON_AVAILABILITY,
                                        convertDate(selectedEbon.expirationDate)
                                    )}
                                </p>
                                <div className="quantity-selector">
                                    <p>{i18n.QUANTITY}</p>
                                    <div className="quantity-button">
                                        <button
                                            onClick={() => handleQuantity('-')}
                                            disabled={quantity <= 1}>
                                            -
                                        </button>
                                        <div>{quantity}</div>
                                        <button
                                            onClick={() => handleQuantity('+')}
                                            disabled={
                                                quantity >= selectedEbon.quantityAvailable ||
                                                (basketLimit && quantity === basketLimit)
                                            }>
                                            +
                                        </button>
                                    </div>
                                </div>

                                {(selectedEbon.quantityAvailable === 1 || basketLimit) && (
                                    <div className="error-area">
                                        {selectedEbon.quantityAvailable === 1 && (
                                            <p>
                                                {convertHtmlToReactDomWithParams(
                                                    i18n.LIMITED_REMAINING_EBON,
                                                    selectedEbon.quantityAvailable,
                                                    selectedEbon.quantityAvailable > 1 ? 's' : ''
                                                )}
                                            </p>
                                        )}
                                        {basketLimit && (
                                            <p>
                                                {convertHtmlToReactDomWithParams(
                                                    i18n.CAPPING_MESSAGE,
                                                    basketLimit,
                                                    basketLimit > 1 ? 's' : ''
                                                )}
                                            </p>
                                        )}
                                    </div>
                                )}

                                <div className="resum-area">
                                    <p>
                                        {selectedEbon.facialValue &&
                                            convertHtmlToReactDomWithParams(
                                                getLabelResume(),
                                                quantity,
                                                formatAmountCurrency(selectedEbon.facialValue),
                                                cashback,
                                                formatAmountCurrency(
                                                    (quantity *
                                                        selectedEbon.facialValue *
                                                        amountCashback) /
                                                        100
                                                )
                                            )}
                                    </p>
                                </div>
                                <div className="button-add">
                                    <ButtonComponent
                                        disabled={isEmpty(selectedEbon) || isBasketLimitReached()}
                                        onClick={() => {
                                            handleAddItem(
                                                selectedEbon.facialValue,
                                                quantity,
                                                selectedEbon.quantityAvailable
                                            );
                                            setSelectedEbon({});
                                        }}
                                        cssClass={`${!selectedEbon.quantityAvailable &&
                                            'none-selected'}`}
                                        color="main"
                                        text={i18n.ADD_BASKET}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right-container">
                        <p>
                            <span>{i18n.BASKET}</span>
                        </p>
                        <div className="cart-container">
                            {cart.length < 1 ? (
                                <p>{i18n.EMPTY_BASKET}</p>
                            ) : (
                                <React.Fragment>
                                    {cart
                                        .sort((a, b) => a.facialValue - b.facialValue)
                                        .map((e, i) => {
                                            const amount =
                                                (e.facialValue || 0) * e.quantityQuery || 0;
                                            return (
                                                <BasketRowItem
                                                    text={`${i18n.BON_ACHAT} - ${partnerName}`}
                                                    ebon={e}
                                                    amount={amount}
                                                    key={i}
                                                    handleItemChange={handleItemChange}
                                                    isBasketLimitReached={isBasketLimitReached()}
                                                />
                                            );
                                        })}
                                </React.Fragment>
                            )}
                        </div>

                        <div>
                            <div className="resum-container">
                                <div className="row-text">
                                    <p>{i18n.DELIVERY}</p>
                                    <p>{i18n.FREE}</p>
                                </div>
                                <div className="row-text red">
                                    <p>{i18n.EBON_CAGNOTTE}</p>
                                    <span className="amount">
                                        +{doCartTotalCashbackAmount(cart)}
                                    </span>
                                </div>
                                <div className="row-text green">
                                    <p>{i18n.TOTAL_TTC}</p>
                                    <span className="amount">
                                        {formatAmountCurrency(getCartTotal(cart))}
                                    </span>
                                </div>
                            </div>
                            <div className="cgv-container">
                                <label className="label">
                                    <input
                                        type="checkbox"
                                        value={CGVAccepted}
                                        onChange={() => setCGVAccepted(!CGVAccepted)}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <p>{convertHtmlToReactDomWithParams(i18n.CGV_TEXT)}</p>
                            </div>
                            <div className="button-add">
                                {isAuthenticated ? (
                                    <ButtonComponent
                                        disabled={!CGVAccepted || cart.length <= 0}
                                        onClick={() => cartValidation()}
                                        color="main"
                                        text={i18n.VALIDATE_BASKET}
                                    />
                                ) : (
                                    <ButtonComponent
                                        disabled={!CGVAccepted || cart.length <= 0}
                                        onClick={showLoginModal}
                                        color="main"
                                        text={i18n.LOGIN_TO_VALIDATE_BASKET}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.MERCHANTCARD.EBON_SELECTOR,
        isAuthenticated: state.authentication.isAuthenticated,
        ebons: state.ebon.ebons,
        fetching: state.ebon.ebonsFetching,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig
    };
};

const mapDispatchToProps = {
    registerCart,
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EbonSelectorComponent));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/EbonSelectorComponent.js